document.addEventListener("DOMContentLoaded", function() {

        const paccordions = document.querySelectorAll(".product-info__sticky-column");

        const toggleAccordion = (paccordion, action) => {
            const pcontent = paccordion.querySelector(".product-accordion__content");
            if (action === 'open') {
                paccordion.classList.add("product-accordion__content-active");
                pcontent.style.maxHeight = pcontent.scrollHeight + "px";
            } else {
                paccordion.classList.remove("product-accordion__content-active");
                pcontent.style.maxHeight = null;
            }
        };

        paccordions.forEach((paccordion) => {
            const pintro = paccordion.querySelector(".summary__title");
            pintro.addEventListener('click', () => {
                const pcontent = paccordion.querySelector(".product-accordion__content");
                if (pcontent.style.maxHeight) {
                    toggleAccordion(paccordion, 'close');
                } else {
                    paccordions.forEach((accordion) => toggleAccordion(accordion, 'close'));
                    toggleAccordion(paccordion, 'open');
                }
            });
        });
    });